
import { required, email, minLength } from "@vuelidate/validators";

import Group from "./group";

export default class Users {
  constructor() {
    this.id = null;
    this.name = null;
    this.contact = null;
    this.email = null;
    this.password = null;
    this.status = true;
    this.group = new Group;
  }
  validations() {
    return {
      name: {
        required,
      },
      contact: {
        required,
      },
      email: {
        required,
        email,
      },
      password: {
        minLength: minLength(6),
      },
      group: {
        required,
      },
    };
  }
}
